// Maximum dimensions for images within document margins
export const MAX_CONTENT_WIDTH = 624; // 816 - 96*2 (page width minus margins)
export const MAX_CONTENT_HEIGHT = 864; // 1056 - 96*2 (page height minus margins)
